module.exports = __webpack_public_path__ + "static/media/time_pollquiz.333899f2.png";